import { IUpdateTradeProposalRequest } from "../interface/trade/Price/IUpdateTradeProposalRequest";
import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum PriceServiceEnum {
    getProposalPriceMaxByTrade = "proposal/max/trade/",
    updateProposalTrade = "proposal/trade"
}

export default class PriceService extends ApiService {
    constructor(restClient: AxiosInstance) {
        super(restClient, "/price/");
    }

    public updateTradeProposal = async (request: IUpdateTradeProposalRequest): Promise<any> => await this.PUT(PriceServiceEnum.updateProposalTrade, request);
    public getProposalPriceMaxByTrade = async (tradeId: number): Promise<any> => await this.GET(PriceServiceEnum.getProposalPriceMaxByTrade + tradeId);
}



// WEBPACK FOOTER //
// ./src/services/api/Price.service.ts